import React from 'react'
import { IProductReserve } from 'product/IProduct'

interface IProductReservesListProps {
  reserves: IProductReserve[]
  className?: string
}

const ProductReservesList: React.FC<IProductReservesListProps> = ({
  reserves,
  className,
}) => {
  return (
    <div className={className}>
      {reserves.length === 0 ? (
        <div className='mx-2'>Нет в наличии</div>
      ) : (
        reserves.map((res) => {
          return res.left_quantity === 0 ? null : (
            <div key={res.office_id} className='mx-2'>
              {res.office_name} : {res.left_quantity} шт.
            </div>
          )
        })
      )}
    </div>
  )
}
export default ProductReservesList
